import { Status } from '~/Api/DataSourceStatus';

import ActionTypes from './ActionTypes';

export interface State {
	request: Promise<any> | null;
	isFetching: boolean;
	statuses: Status[] | null;
}

type Action =
	| { type: ActionTypes.request; request: Promise<any> }
	| {
			type: ActionTypes.receive;
			request: Promise<any>;
			statuses: Status[] | null;
	  };

export default function reducer(state: State = createState(), action: Action): State {
	switch (action.type) {
		case ActionTypes.request:
			return { ...state, request: action.request, isFetching: true };

		case ActionTypes.receive:
			return state.request === action.request
				? {
						...state,
						request: action.statuses ? action.request : null,
						isFetching: false,
						statuses: action.statuses,
				  }
				: createState();

		default:
			return state;
	}
}

function createState(): State {
	return {
		request: null,
		isFetching: false,
		statuses: null,
	};
}
